import React from 'react'

const OwnerDefectReport = ({ state, handleChange, handlePhotoChange, onSubmit, isFinalSubmitting, setIsFinalSubmitting, }) => {
    return (
        <div className="row">
            <div className="col-lg-12">
                <div className="card">
                    <div className="card-body">
                        {/* <div className="row">
          <div className="col-md-12">
            <div className="checklist-title-bx">
              <h4 style={{ marginBottom: 0 }}>OSS XXXXX Site Office</h4>
              <p>site office address:</p>
              <p>Tel (Office): (xx)-xx-xxxx xxxx</p>
              <p>email: xxxxxxxxxxxxxxxxxx</p>
            </div>
          </div>
        </div> */}
                        <div className="row">
                            <div className="col-md-12">
                                <div className="appraisal-report-table-responsive">
                                    <table className="assessment-table" cellSpacing={0}>
                                        <tbody>
                                            <tr>
                                                <td className="td-s1 td-s1-heading" colSpan={6}>
                                                    <p className="s1">OWNER’S DEFECT REPORT</p>
                                                </td>
                                            </tr>
                                            <tr>
                                                <td className="hd-s2 pd10 w150">
                                                    {" "}
                                                    <p>Hull Number</p>
                                                </td>
                                                <td className="tb-input-value">
                                                    <select
                                                        type="text"
                                                        className="form-control"
                                                        placeholder="Enter Hull Number"
                                                        defaultValue=""
                                                        name={state.ship.name}
                                                        value={state.ship.value}
                                                        onChange={handleChange}
                                                    >
                                                        <option value={''}> Select Hull</option>

                                                        {
                                                            state.ship.options.map((item) => {
                                                                return (<option value={item.ID}> {item.HULL_NUMBER} - {item.SHIP_NAME}</option>)
                                                            })
                                                        }
                                                    </select>
                                                </td>
                                                <td className="hd-s2 pd10 w150">
                                                    <p>Issue Date</p>
                                                </td>
                                                <td className="tb-input-value">
                                                    <input
                                                        type="date"
                                                        className="form-control"
                                                        placeholder="Enter Issue Date"
                                                        name={state.issueDate.name}
                                                        value={state.issueDate.value}
                                                        onChange={handleChange}
                                                    />
                                                </td>
                                                <td className="hd-s2 pd10 w150">
                                                    {" "}
                                                    <p>Defect Number</p>
                                                </td>
                                                <td className="tb-input-value">
                                                    <input
                                                        type="text"
                                                        className="form-control"
                                                        placeholder="Enter Defect Number"
                                                        name={state.defectNumber.name}
                                                        value={state.defectNumber.value}
                                                        onChange={handleChange}
                                                    />
                                                </td>
                                            </tr>
                                            <tr>
                                                <td className="hd-s2 pd10 w150">
                                                    <p>Issued By</p>
                                                </td>
                                                <td className="tb-input-value">
                                                    <select
                                                        type="text"
                                                        className="form-control"
                                                        placeholder="Enter Issued By"
                                                        name={state.issuedBy.name}
                                                        value={state.issuedBy.value}
                                                        onChange={handleChange}
                                                    >
                                                        <option value={''}>Select Issued By</option>
                                                        {state.issuedBy.options.map((item) => {
                                                            return (<option value={item.USER_ID}>{item.FULL_NAME}</option>)
                                                        })

                                                        }
                                                    </select>
                                                </td>
                                                <td className="hd-s2 pd10 w150">
                                                    {" "}
                                                    <p>To</p>
                                                </td>
                                                <td className="tb-input-value">
                                                    <select
                                                        className="form-control"
                                                        placeholder="To"
                                                        name={state.to.name}
                                                        value={state.to.value}
                                                        onChange={handleChange}
                                                    >
                                                        <option value={''}>Select Issued By</option>
                                                        {state.to.options.map((item) => {
                                                            return (<option value={item.USER_ID}>{item.FULL_NAME}</option>)
                                                        })

                                                        }
                                                    </select>
                                                </td>
                                                <td className="hd-s2 pd10 w150">
                                                    <p>CC</p>
                                                </td>
                                                <td className="tb-input-value">
                                                    <select
                                                        type="text"
                                                        className="form-control"
                                                        placeholder="CC"
                                                        name={state.cc.name}
                                                        value={state.cc.value}
                                                        onChange={handleChange}
                                                    >
                                                        <option value={''}>Select Issued By</option>
                                                        {state.cc.options.map((item) => {
                                                            return (<option value={item.USER_ID}>{item.FULL_NAME}</option>)
                                                        })

                                                        }
                                                    </select>
                                                </td>
                                            </tr>
                                            <tr>
                                                <td className="hd-s2 pd10">
                                                    {" "}
                                                    <p>Location</p>
                                                </td>
                                                <td colSpan={6} className="tb-input-value">
                                                    <input
                                                        type="text"
                                                        className="form-control"
                                                        placeholder="Enter Location"
                                                        name={state.location.name}
                                                        value={state.location.value}
                                                        onChange={handleChange}
                                                    />
                                                </td>
                                            </tr>
                                            <tr>
                                                <td className="hd-s2 pd10">
                                                    {" "}
                                                    <p>Subject</p>
                                                </td>
                                                <td colSpan={6} className="tb-input-value">
                                                    <input
                                                        type="text"
                                                        className="form-control"
                                                        placeholder="Enter Subject"
                                                        name={state.subject.name}
                                                        value={state.subject.value}
                                                        onChange={handleChange}
                                                    />
                                                </td>
                                            </tr>
                                            <tr>
                                                <td className="td-s1 td-s1-heading" colSpan={6}>
                                                    <p className="s1">DESCRIPTION</p>
                                                </td>
                                            </tr>
                                            <tr>
                                                <td colSpan={6} className="tb-input-value">
                                                    <textarea
                                                        className="form-control"
                                                        placeholder=""
                                                        name={state.description.name}
                                                        value={state.description.value}
                                                        onChange={handleChange}
                                                    />
                                                </td>
                                            </tr>
                                            <tr>
                                                <td className="td-s1 td-s1-heading" colSpan={6}>
                                                    <p className="s1">PHOTOS</p>
                                                </td>
                                            </tr>
                                            <tr>
                                                <td colSpan={6} className="tb-input-value">
                                                    {state.ship.value ? <input
                                                        type='file'
                                                        onChange={handlePhotoChange}
                                                    /> : ''}
                                                    {state.photos.value.map((item) => {
                                                        return (
                                                            <div className="photo-section">
                                                                <div className="image-upload">
                                                                    <img
                                                                        src={`${process.env.REACT_APP_BASE_URL}/v3/production-form/owner-defect-report/file/${state.ship.value}/${item}`}
                                                                        alt="" />
                                                                </div>
                                                            </div>

                                                        )
                                                    })}
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                                <div className="row">
                                    <div className="col-lg-6">
                                        <table className="mrt10 mt-4 wd100">
                                            <tbody>
                                                <tr>
                                                    <td className="hd-b" colSpan={5}>
                                                        <p>BUILDER’S REPLY : (within 5 days after issuance)</p>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td colSpan={5} className="input-textarea">
                                                        <textarea
                                                            className="form-control"
                                                            placeholder=""
                                                            defaultValue={""}
                                                        />
                                                    </td>
                                                </tr>
                                                <tr className="bottom-sig-tr2-box ">
                                                    <td className="input-td">
                                                        <p className="s2  mt-4">Signature</p>
                                                    </td>
                                                    <td>
                                                        <p className="s1">
                                                            <input
                                                                type="text"
                                                                className="form-control"
                                                                placeholder=""
                                                                defaultValue=""
                                                            />
                                                        </p>
                                                    </td>
                                                    <td className="w50" />
                                                    <td className="input-td">
                                                        <p className="s2  mt-4">DATE</p>
                                                    </td>
                                                    <td>
                                                        <p className="s1">
                                                            <input
                                                                type="text"
                                                                className="form-control"
                                                                placeholder=""
                                                                defaultValue=""
                                                            />
                                                        </p>
                                                    </td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                    <div className="col-lg-6">
                                        <table className="mrt10 mt-4 wd100">
                                            <tbody>
                                                <tr>
                                                    <td className="hd-b">
                                                        <p>VERIFIED</p>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td className="input-textarea" colSpan={5}>
                                                        <textarea
                                                            className="form-control"
                                                            placeholder=""
                                                            defaultValue={""}
                                                        />
                                                    </td>
                                                </tr>
                                                <tr className="bottom-sig-tr2-box mrt10">
                                                    <td className="input-td">
                                                        <p className="s2  mt-4">Signature</p>
                                                    </td>
                                                    <td>
                                                        <p className="s1">
                                                            <input
                                                                type="text"
                                                                className="form-control"
                                                                placeholder=""
                                                                defaultValue=""
                                                            />
                                                        </p>
                                                    </td>
                                                    <td className="w50" />
                                                    <td className="input-td">
                                                        <p className="s2  mt-4">DATE</p>
                                                    </td>
                                                    <td>
                                                        <p className="s1">
                                                            <input
                                                                type="text"
                                                                className="form-control"
                                                                placeholder=""
                                                                defaultValue=""
                                                            />
                                                        </p>
                                                    </td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                                <div class="final-checkbox">
                                    <div class="form-check mt-2">
                                        <input class="form-check-input" name="discountCheckbox" type="checkbox" checked={isFinalSubmitting} onChange={() => { setIsFinalSubmitting() }} id="productdiscountCheck1" />
                                        <label class="form-check-label" for="productdiscountCheck1">Send New Building Pre Launching Check List to Office for Review</label>
                                    </div>
                                </div>
                                <div className="row mt-5">
                                    <div className="col-lg-12 text-left ">
                                        <button
                                            className="btn btn-success text-white"
                                            style={{
                                                backgroundImage: "linear-gradient(90deg, #6996b5, #2b5a7e)",
                                                borderColor: "#2b5a7e"
                                            }}
                                            onClick={() => {
                                                onSubmit()
                                            }}
                                        >
                                            Submit
                                        </button>
                                        <button
                                            type="reset"
                                            className="btn btn-danger ms-3"
                                            style={{
                                                backgroundImage: "linear-gradient(90deg, #6996b5, #2b5a7e)",
                                                borderColor: "#2b5a7e"
                                            }}
                                        >
                                            Cancel
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

    )
}

export default OwnerDefectReport